"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = exports.TextInput = exports.Field = exports.CheckBox = exports.TextArea = exports.RadioButton = void 0;
var RadioButton_1 = __importDefault(require("./RadioButton"));
exports.RadioButton = RadioButton_1.default;
var TextArea_1 = __importDefault(require("./TextArea"));
exports.TextArea = TextArea_1.default;
var CheckBox_1 = __importDefault(require("./CheckBox"));
exports.CheckBox = CheckBox_1.default;
var Field_1 = __importDefault(require("./Field"));
exports.Field = Field_1.default;
var TextInput_1 = __importDefault(require("./TextInput"));
exports.TextInput = TextInput_1.default;
var Switch_1 = __importDefault(require("./Switch"));
exports.Switch = Switch_1.default;
exports.default = { RadioButton: RadioButton_1.default, TextArea: TextArea_1.default, CheckBox: CheckBox_1.default, Field: Field_1.default, TextInput: TextInput_1.default, Switch: Switch_1.default };
